type CityData = { name: string; latitude: number; longitude: number, timezone: string };
type CountryData = Record<string, CityData[]>;

export const countries: CountryData = {
    "Ukraine": [
        { name: "Khmelnitskiy", latitude: 49.41944, longitude: 26.97944, timezone:"+2:00 Europe/Kiev" },
        { name: "Uzh'Horod", latitude: 48.62389, longitude: 22.29500, timezone:"+2:00 Europe/Kiev"  },
        { name: "Ivano-Frankivsk", latitude: 48.9215, longitude: 24.70972, timezone:"+2:00 Europe/Kiev"  }
    ],
    "Switzerland": [
        { name: "Geneva", latitude: 46.204391, longitude: 6.143158, timezone:"+1:00 Europe/Zurich"  },
        { name: "Basel", latitude: 47.559601, longitude: 7.588576, timezone:"+1:00 Europe/Zurich"  },
        { name: "Lauzanne", latitude: 46.519962, longitude: 6.633597, timezone:"+1:00 Europe/Zurich"  },
        { name: "St. Gallen", latitude: 47.4239, longitude: 9.3748, timezone:"+1:00 Europe/Zurich"  }
    ]
};

export const getLocalCitiesByCountry = (country: string) => {
    return countries[country] || [];
}
